import { formatAmountCompact as formatAmountCompactRaw, formatMajorAmount as formatMajorAmountRaw, formatMinorAmount as formatMinorAmountRaw, formatPriceDifference as formatPriceDifferenceRaw, isOperatingCurrencyCode, } from '@owner/currency';
const currencyOptions = (locale, options) => ({
    ...options,
    bcpTag: locale.tag,
    currency: locale.currency,
});
export const formatMajorAmount = (amount, locale, options) => formatMajorAmountRaw(amount, currencyOptions(locale, options));
export const formatMinorAmount = (amount, locale, options) => formatMinorAmountRaw(amount, currencyOptions(locale, options));
export const normalizeOperatingCurrencyCode = (currency) => {
    if (typeof currency !== 'string')
        return undefined;
    const normalizedCurrency = currency.trim().toUpperCase();
    return isOperatingCurrencyCode(normalizedCurrency)
        ? normalizedCurrency
        : undefined;
};
export const formatMinorAmountForCurrency = (amount, currency, locale, options) => {
    const normalizedCurrency = normalizeOperatingCurrencyCode(currency);
    if (normalizedCurrency == null) {
        return formatMinorAmountRaw(amount, currencyOptions(locale, { ...options, includeSymbol: false }));
    }
    return formatMinorAmountRaw(amount, currencyOptions({ ...locale, currency: normalizedCurrency }, options));
};
export const formatAmountCompact = (amount, locale, options) => formatAmountCompactRaw(amount, currencyOptions(locale, options));
export const formatPriceDifference = (amount, locale, options) => formatPriceDifferenceRaw(amount, currencyOptions(locale, options));
//# sourceMappingURL=formatAmount.js.map